import React from 'react';
import usePrivateMessage from '../hooks/usePrivateMessage';
import Label from '../utils/label';

export default function PrivateMessageButton() {

    const {
        privateMessageCount,
        openPrivateMessage
    } = usePrivateMessage();

    return (
        <div className="top-nav__mail btn btn-primary" title={Label.lbl_privatemsg} onClick={openPrivateMessage}>
            <i className="icon-envelope2" />
            {privateMessageCount > 0 && <div className="alert">{privateMessageCount}</div>}
        </div>
    );
}
